import React from 'react';
import { useFormikContext } from 'formik';
import {
  Box,
  Button,
  Checkbox, CircularProgress,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

export const ReportMultiSelect = props => {
  const {
    options = [],
    name,
    onSelect,
    label,
    valueProperty = 'value',
    labelProperty = 'label',
    disabled = false,
    loading = false,
    selectAll = false,
  } = props;
  const { values } = useFormikContext();

  return (
    <>
      <FormControl variant="outlined" fullWidth>
        <InputLabel id={`multi-select-${name}`}>{label}</InputLabel>
        <Select
          labelId={`multi-select-${name}`}
          name={name}
          multiple
          value={values[name] || []}
          onChange={onSelect}
          label={label}
          disabled={loading || disabled}
          IconComponent={loading ? 'span' : ArrowDropDownIcon}
          endAdornment={loading && <CircularProgress size="1rem" color="default" />}
          renderValue={selected => {
            if (selected.length === 1) {
              return <em>1 item selecionado</em>;
            } else if (selected.length > 1) {
              return <em>{selected.length} itens selecionados</em>;
            }
          }}
        >
          {options.map(option => (
            <MenuItem key={option[valueProperty]} value={option[valueProperty]}>
              <Checkbox
                checked={values[name] && values[name].indexOf(option[valueProperty]) > -1}
              />
              <ListItemText primary={option[labelProperty]} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Box width="100%" display="flex" justifyContent="space-between">
        <Button
          variant="text"
          size="small"
          color="default"
          disabled={loading || disabled}
          onClick={() => onSelect({ target: { name, value: [] } })}
          style={{ marginTop: '6px' }}
        >
          Limpar seleção
        </Button>
        {!!selectAll && (
          <Button
            variant="outlined"
            size="small"
            color="default"
            disabled={loading || disabled}
            onClick={() =>
              onSelect({ target: { name, value: options.map(o => o[valueProperty]) } })
            }
            style={{ marginTop: '6px' }}
          >
            Selecionar todos
          </Button>
        )}
      </Box>
    </>
  );
};
